var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NetworkVisualCue"},[_c('router-link',{attrs:{"to":{name: 'settings'}}},_vm._l((_vm.hyphenCustom),function(n){return _c('span',{key:n},[_c('span',[_vm._v(_vm._s(n)),_c('br')])])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }